import { render } from "./BaseSvgIcon.vue?vue&type=template&id=99e0c8d2&scoped=true&ts=true"
import script from "./BaseSvgIcon.vue?vue&type=script&lang=ts"
export * from "./BaseSvgIcon.vue?vue&type=script&lang=ts"

import "./BaseSvgIcon.vue?vue&type=style&index=0&id=99e0c8d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99e0c8d2"]])

export default __exports__